import React, { useEffect, useState } from 'react';
import { Card, List } from 'antd';
import Navbar from '../navbar/Navbar';
import { useNavigate } from 'react-router-dom';

const Profile = () => {
  const [user, setUser] = useState(null);
  const navigate = useNavigate();

  useEffect(() => {
    const currentUser = JSON.parse(localStorage.getItem('currentUser'));
    setUser(currentUser);
    if(currentUser == null){
      navigate('/')
      window.location.reload()
    }
    console.log(currentUser)
  }, []);

  if (user==null) {
    return (<>
     <Navbar/>
     <div>Loading...</div>
    </>);
  }

  const userInfo = [
    { title: 'Username', value: user.username },
    { title: 'Wins', value: user.win },
    { title: 'Losses', value: user.lose },
    { title: 'Draws', value: user.draw },
    { title: 'Score', value: user.score },
    { title: 'Streak', value: user.streak },
  ];

  return (
    <>
        <Navbar/>
        
        <div style={{ padding: 24 }}>
          <h1 style={{color:'white',textAlign:'center'}}>Profile</h1>
        <Card bordered={false} style={{ width: 300, margin: 'auto',backgroundColor:'#5F374B' }}>
            <List
          
            itemLayout="horizontal"
            dataSource={userInfo}
            renderItem={item => (
                <List.Item>
                <List.Item.Meta
                  title={<span style={{ color: 'white' }}>{item.title}</span>}
                  description={<span style={{ color: 'white' }}>{item.value}</span>}
                />
                </List.Item>
            )}
            />
        </Card>
        </div>
    </>
  );
};

export default Profile;
